import { useAccountingStore } from '@/stores/accounting';
import ROUTES from '@/utils/constants/accounting/routes_names';
import USER_PERMISSIONS from '@/utils/constants/accounting/permissions_aliases';

const actions = [
    {
        routeName: ROUTES.AP_PAYMENTS.name,
        items: [
            {
                title: 'add new payment',
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_NEW_PAYMENT);
                },
                routeName: ROUTES.AP_PAYMENTS_ADD_NEW.name,
            },
        ],
    },
];

export default actions;
